import { Topbar } from '@/components/organisms/Topbar';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * `/billing` route pending state: Topbar + skeleton blocks mirroring
 * `BillingPage`'s real card layout — a 760px column (subscription + usage),
 * a full-width pricing grid (`UpgradePlansCard`), then another 760px column
 * (invoices + changelog + capabilities). Each real card self-gates its own
 * loading/error state; this only covers the route-transition gap before the
 * profile-priming query resolves.
 */
export function BillingPendingState() {
  return (
    <>
      <Topbar crumbs={[{ label: 'Account' }, { label: 'Billing' }]} title="Billing" />

      <div
        className="flex min-h-0 flex-1 flex-col overflow-auto"
        style={{ background: 'var(--canvas)' }}
      >
        <div
          className="flex w-full max-w-[1280px] flex-col gap-6 px-4 py-6 md:px-8 md:py-6"
          aria-busy="true"
          aria-live="polite"
        >
          <section className="flex min-w-0 flex-col gap-6" style={{ maxWidth: 760 }}>
            <Skeleton className="h-40 w-full rounded-lg" />
            <Skeleton className="h-40 w-full rounded-lg" />
          </section>

          <div
            className="grid gap-4"
            style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}
          >
            {Array.from({ length: 3 }, (_, i) => (
              <Skeleton key={i} className="h-56 rounded-lg" />
            ))}
          </div>

          <section className="flex min-w-0 flex-col gap-6" style={{ maxWidth: 760 }}>
            <Skeleton className="h-40 w-full rounded-lg" />
            <Skeleton className="h-32 w-full rounded-lg" />
            <Skeleton className="h-32 w-full rounded-lg" />
          </section>
        </div>
      </div>
    </>
  );
}
